<template>
  <div v-if="loaded">
    <ConnectionsList v-if="currentUserIsOwner" :connections="connections" :isSummary="true" />
    <BadgesList
      v-if="badges && badges.length"
      :isPreview="true"
      :isProfilePremium="isProfilePremium"
      :currentUserIsOwner="currentUserIsOwner"
      :nrBadgesToShow="NR_BADGES_IN_MAIN"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import BadgesList from "./BadgesList";
import ConnectionsList from "./ConnectionsList";

import profileAPIService from "../../../api/profileAPIService";
import { BadgeStore } from "../../../ELYX/ELYXStore";

export default {
  name: "ProfileTabMain",
  components: {
    BadgesList,
    ConnectionsList,
  },
  props: {
    profileOwnerID: String,
    currentUserIsOwner: Boolean,
    isProfilePremium: Boolean,
  },
  data() {
    return {
      NR_CONNECTIONS_IN_MAIN: 3,
      NR_BADGES_IN_MAIN: 3,
      loaded: false,
      connections: [],
    };
  },
  computed: {
    badges: () => BadgeStore.state.badges,

    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  async created() {
    const result = await profileAPIService.getConnections(this.user._id, this.NR_CONNECTIONS_IN_MAIN, 0);
    if (result !== null) {
      this.connections = result.connections;
    }
    this.loaded = true;
  },
};
</script>
